import { BaseControlBehaviour } from './BaseControlBehaviour';

declare class AwesomeScrollbar {
    constructor(containerSelector: any, addClass: string);
}

/**
 * Scrollbar - устанавливает Scrollbar
 */
export class ScrollbarBehaviour extends BaseControlBehaviour {
    constructor() {
        super('scrollbar');
    }

    protected installBehaviour(element: any): void {
        if ((<any>window).globalAppSettings.isMobileDevice) {
            return;
        }

        new AwesomeScrollbar($(element), this.getBehaviorValue(element));
    }
}

if(!window.Behaviours) window.Behaviours = {};
window.Behaviours.ScrollbarBehaviour = ScrollbarBehaviour;